<template>
    <div class="container-fluid px-0" ref="legalTitleSection">
        <!-- Breadcrumbs (Large screens) -->
        <nav aria-label="breadcrumb" class="d-none d-md-flex mt-3">
            <ol class="breadcrumb">
                <li class="breadcrumb-item">
                    <router-link to="/" class="text-decoration-none">
                        Home
                    </router-link>
                </li>
                <li class="breadcrumb-item active" aria-current="page">{{ title }}</li>
            </ol>
        </nav>

        <!-- Title  (Large screens) -->
        <h2 class="d-none d-md-block fw-bold text-start mb-large">{{ title }}</h2>

        <!-- Nav (Small screens) -->
        <div class="d-md-none d-flex align-items-center justify-content-between small-nav">
            <!-- Back icon -->
            <a v-load-page="'/'" v-ripple class="navbar-brand fw-bold fs-4 py-0 m-0 rounded-circle">
                <i class="hoverable-icon bi-arrow-left"></i>
            </a>
            <!-- Title -->
            <p class="fs-5 fw-bold m-0">{{ title }}</p>
            <!-- Menu toggler -->
            <i class="hoverable-icon bi-three-dots-vertical" v-ripple></i>
        </div>
    </div>
    
    <div class="divider sm mt-3 d-none d-md-block"></div>

    <div ref="legalContentSection" class="mt-3" v-html="content">
        
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import apiClient from '@/utils/axios.js';
import { useHttpErrorManager } from '@/composables/useHttpErrorManager.js';
import { useAppHelpers } from '@/composables/useAppHelpers.js';

const helper = useAppHelpers();

const props = defineProps({
    slug: String
});

const legalContentSection = ref(null);
const legalTitleSection = ref(null);

const content = ref('');
const title = ref('');

const loadContent = async () => {
    if (props.slug) {
        helper.loaderOn(legalContentSection.value);
        helper.loaderOn(legalTitleSection.value);
        let url = "/company/legal/" + props.slug;

        try {
            const response = await apiClient.get(url, {});
            if (response.status === 200) {
                content.value = response.data.page.content
                title.value = response.data.page.title
            } 
            helper.loaderOff(legalContentSection.value);
            helper.loaderOff(legalTitleSection.value);
        } catch (error) {
            let errorObj = await useHttpErrorManager().handleError(error, false);
            helper.loaderOff(legalContentSection.value);
            helper.loaderOff(legalTitleSection.value);
        }
    }
}

onMounted(() => {
    loadContent();
});


</script>
  